import { createElement } from "@max/max";
import View from '@hfe/max-view';
import { AmountType } from '@/types/shared';
import CouponTitle from '../../common/CouponTitle';
import CouponThreshold from '../../common/CouponThreshold';
import CountDownDescription, { TextType } from '../../common/CountDownDescription';
import './index.scss';
import { LayoutType } from '../../../types/shared';
import Button from '@/components/common/Button';
import Price from "@/components/common/Price/index.web";
import { IS_IOS } from '@/hooks/useRequest';
import { formatRequireAmount } from '@/utils/common';
const CouponCardDouble = ({ prize, onPress }) => {
    const isButtonValid = prize.isButtonValid;
    const requireAmount = formatRequireAmount(prize.requireAmount);
    return <View className="coupon-card-double" onClick={() => onPress(prize)}>
      <View className="coupon-content-double">
        <View className="left-section-double">
          <View className="price-wrapper-double" style={{
            marginTop: IS_IOS ? '16rpx' : '0rpx'
        }}>
            <Price amount={prize.amount} amountType={prize.amountType || AmountType.FULL_REDUCTION} rewardType={prize.rewardType} layoutType={LayoutType.DOUBLE}/>
          </View>
          <CouponThreshold text={requireAmount} className="threshold-double" style={{
            marginTop: '-10rpx'
        }}/>
        </View>

        <View className="right-section-double">
          <CouponTitle title={prize.prizeName} layoutType={LayoutType.DOUBLE} className="title-double"/>
          
          <View style={{
            height: "38rpx"
        }}>
            <CountDownDescription prize={prize} textType={TextType.SMALL} className="countdown-double"/>
          </View>

          <Button width={136} height={48} fontSize={24} children={prize.buttonText || '领取'} backgroundColor={isButtonValid ? '#FF2D19' : '#CCCCCC'} handlePress={() => onPress(prize)} className="button-double">
          </Button>
        </View>
      </View>
    </View>;
};
export default CouponCardDouble;
